import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=6e43e647&scoped=true"
import script from "./Panels.vue?vue&type=script&lang=ts"
export * from "./Panels.vue?vue&type=script&lang=ts"
import style0 from "./Panels.vue?vue&type=style&index=0&id=6e43e647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43e647",
  null
  
)

export default component.exports